import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StatusHandler } from '../../../components'
import { fetchOrganizations as fetcher } from '../../../features/organizations/slice'
// import { useOrganizations } from "../../../features/organizations"
import { useViewport } from "../../../utils"
import { MainContent } from "./main-content"
import { MainContentMobile } from "./main-content-mobile"

const PageContent = () => {
  const dispatch = useDispatch()
  const { isDesktop } = useViewport()
  const {data, status, error} = useSelector(state => state.organizations)

  return (
    <StatusHandler
      status={status}
      error={error}
      onRetry={() => dispatch(fetcher())}
    >
      {
        isDesktop ? (
          <MainContent organizations={data}/>
        ) : (
          <MainContentMobile organizations={data}/>
        )
      }
    </StatusHandler>
  )
}

export { PageContent }
